<template>
  <el-dialog v-model="show" @close="handleClose">
    <template #header>
      提示
    </template>

    <i class="el-icon-info" style="color: #E6A23C;" />操作失败，失败原因如下：
    <el-table-v2
      :columns="tableData"
      :data="items"
      :pagination="false"
      style="height: 280px"
    >
    </el-table-v2>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      items: [],
      tableData: [
        {
          title: "名称",
          dataIndex: "name"
        },
        {
          title: "失败原因",
          dataIndex: "error_reason"
        }
      ]
    };
  },
  methods: {
    handleOpen(val) {
      this.items = val;
      this.show = true;
    },
    handleClose() {
      this.show = false;
    }
  }
};
</script>

<style scoped>
.textItem {
  line-height: 30px;
}
</style>
